import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { MapPinIcon, PhoneIcon, MailIcon, ArrowLeft } from 'lucide-react';
interface Slide9Props {
  onNavigate: (slide: number) => void;
}
export function Slide9({
  onNavigate
}: Slide9Props) {
  return <SlideLayout onBack={() => onNavigate(7)} data-id="element-239">
      <div className="w-full max-w-4xl mx-auto space-y-12" data-id="element-240">
        <h1 className="text-4xl font-bold text-primary text-center mb-8" data-id="element-241">
          Contact Roche Côte d'Ivoire
        </h1>
        <div className="bg-white rounded-2xl shadow-xl p-12 border border-teal-100/50 space-y-8" data-id="element-242">
          <div className="text-center mb-8" data-id="element-243">
            <h2 className="text-2xl font-bold text-primary mb-2" data-id="element-244">
              Roche Côte d'Ivoire SARL
            </h2>
          </div>
          <div className="space-y-6" data-id="element-245">
            <div className="flex items-start gap-4" data-id="element-246">
              <MapPinIcon className="w-6 h-6 text-accent flex-shrink-0 mt-1" data-id="element-247" />
              <div data-id="element-248">
                <p className="text-base text-gray-700 font-semibold mb-1" data-id="element-249">
                  Address
                </p>
                <p className="text-gray-600" data-id="element-250">
                  Ivoire Trade Center, Cocody les Ambassades
                </p>
                <p className="text-gray-600" data-id="element-251">
                  Angle Rue Hassan II & Rue Booker Washington
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-252">
              <PhoneIcon className="w-6 h-6 text-accent flex-shrink-0 mt-1" data-id="element-253" />
              <div data-id="element-254">
                <p className="text-base text-gray-700 font-semibold mb-1" data-id="element-255">
                  Phone
                </p>
                <p className="text-gray-600" data-id="element-256">+225 27 22 48 23 55</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-257">
              <MailIcon className="w-6 h-6 text-accent flex-shrink-0 mt-1" data-id="element-258" />
              <div data-id="element-259">
                <p className="text-base text-gray-700 font-semibold mb-1" data-id="element-260">
                  Email
                </p>
                <p className="text-gray-600" data-id="element-261">
                  westafricapharmacovigilance@roche.com
                </p>
                <p className="text-gray-600" data-id="element-262">westafrica.medinfo@roche.com</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center gap-4 pt-4" data-id="element-263">
          <Button variant="secondary" onClick={() => onNavigate(7)} data-id="element-264">
            Back to additional resources
          </Button>
          <Button variant="primary" onClick={() => onNavigate(2)} data-id="element-265">
            <ArrowLeft className="w-5 h-5" data-id="element-266" />
            Back to main menu
          </Button>
        </div>
      </div>
    </SlideLayout>;
}